import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, ToastOptions, toast } from 'react-toastify'

const Snackbar = () => {
    const { open, type, message ,customVisibleTime } = useSelector((state: any) => state.snackbar);
    type toastEmitterType = {
        position: string;
        autoClose: number;
        hideProgressBar: boolean;
        closeOnClick: boolean;
        pauseOnHover: boolean;
        draggable: boolean;
        progress: undefined;
        theme: string;
    }
    const toastEmitter: ToastOptions<toastEmitterType> = {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light"
    }
    switch (type) {
        case 'success': toast.success(message, toastEmitter);
            break;
        case 'error': toast.error(message, {...toastEmitter,autoClose : customVisibleTime ? customVisibleTime : 3000 });
            break;
        case 'info': toast.info(message, toastEmitter);
            break;
        case 'warn': toast.warn(message, toastEmitter);
            break;
        default: ;
            break;
    }

    return (
        <>
            {open && <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />}
        </>   
    )
}

export default Snackbar